<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="archiving-settings.info.title"></h4>
  </div>
  <div class="modal-body">
    <app-info title="Hinweis">
      <p [innerHtml]="'archiving-settings.info.subtitle' | translate"></p>
    </app-info>

    <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th translate>kwh.actions.archiving.table.doc-type</th>
          <th class="has-text-centered" translate>
            kwh.actions.archiving.table.incoming
          </th>
          <th class="has-text-centered" translate>
            kwh.actions.archiving.table.outgoing
          </th>
        </tr>
      </thead>
      <tbody>
        @for (docType of archivingDocTypes | keyvalue; track docType.value) {
          <tr>
            <td
              [translate]="'kwh.actions.archiving.docTypes.' + docType.value"
            ></td>
            <td class="has-text-centered">
              @if (archivingPossible('NEW_BANK', docType.value)) {
                <form
                  class="ml-1 is-flex is-justify-content-center"
                  [formGroup]="archivingForm"
                  novalidate
                >
                  <fino-checkbox
                    [formControlName]="'NEW_BANK_' + docType.value"
                    label=""
                  ></fino-checkbox>
                </form>
              } @else {
                <fino-icon
                  class="icon"
                  icon="Road Sign No Entry"
                  type="bold"
                ></fino-icon>
              }
            </td>
            <td class="has-text-centered">
              @if (archivingPossible('OLD_BANK', docType.value)) {
                <form
                  class="ml-1 is-flex is-justify-content-center"
                  [formGroup]="archivingForm"
                  novalidate
                >
                  <fino-checkbox
                    [formControlName]="'OLD_BANK_' + docType.value"
                    label=""
                  ></fino-checkbox>
                </form>
              } @else {
                <fino-icon
                  class="icon"
                  icon="Road Sign No Entry"
                  type="bold"
                ></fino-icon>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (archivingFormInvalid) {
      <div class="notification is-danger" [translate]="errorMessage"></div>
    }
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        (click)="submit()"
        [loading]="buttonLoading"
        fino-button
        label="archiving-settings.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="archiving-settings.abort"
      ></button>
    </div>
  </div>
</div>
